function wrap(callback, n) {
  let t = 0;
  return () => {
    if (t++ >= n) {
      t = 0;
      callback();
    }
  };
}
export default class Ticker {
  constructor(app) {
    this.app = app;
    this.timer = null;
    this.callbacks = [];
  }
  attach(callback) {
    let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let useSafe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let thisArg = arguments.length > 3 ? arguments[3] : undefined;
    if (thisArg) {
      callback = callback.bind(thisArg);
    }
    if (useSafe) {
      callback = this.app.safe(callback);
    }
    this.callbacks.unshift(n ? wrap(callback, n) : callback) - 1;
  }
  start() {
    if (this.timer === null) {
      this.timer = setInterval(() => this.callbacks.forEach(cb => {
        if (cb) cb();
      }), 30);
    }
  }
  stop() {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}